import type { IconData } from '@stacksjs/iconify-core'

export const arrowLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M497.333 239.999H80.092l95.995-95.995l-22.627-22.627L18.837 256L153.46 390.623l22.627-22.627l-95.997-95.997h417.243z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowLeft
